<template>
  <v-container
    class="px-0"
  >
    <v-row
      class="my-6 no-gutters"
    >
      <v-col
        class="px-3 px-md-0"
      >
        <v-alert
          light
          border="left"
          color="brand"
          class="pa-8"
        >
          <v-row>
            <v-col
              cols="12"
            >
              <v-row>
                <v-col
                  cols="12"
                  class="text-h4 white--text"
                >
                  {{ $t('home.headline') }}
                </v-col>
                <v-col
                  cols="12"
                  class="text-h6 white--text"
                >
                  {{ $t('home.intro') }}
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-sheet
                light
                color="tileBg"
                class="pa-2"
              >
                <v-row
                  align="center"
                >
                  <v-col
                    cols="12"
                  >
                    <div id="video-wrapper">
                      <Media
                        ref="videoEl"
                        :kind="'video'"
                        :src="[videoSource]"
                        :poster="posterSource"
                        :type="videoType"
                        :autoplay="false"
                        :controls="true"
                        :controlsList="['nodownload']"
                        :loop="false"
                        :muted="false"
                        @play="videoPlaying()"
                        @pause="videoStopped()"
                        disablepictureinpicture
                        preload="metadata"
                        style="width: 100%; outline: none !important;"
                      />
                    </div>
                    <div class="text-right">
                      <v-btn
                        x-small
                        text
                        :color="audioDescription ? 'brand' : 'grey'"
                        @click="toggleAudioDescription"
                      >
                        <v-icon left x-small>mdi-ear-hearing</v-icon>
                        {{ audioDescription ? $t('home.video.ad.on') : $t('home.video.ad.off') }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    class="text-subtitle-2"
                    cols="12"
                    :style="{
                      'color': 'var(--v-brand-base)'
                    }"
                  >
                  {{ $t('home.video.description') }}
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
    <Navigation
      :items="items"
    />
  </v-container>
</template>

<script>
import Navigation from '@/views/components/Navigation.vue'
import Media from '@/views/components/VideoPlayer.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    Navigation,
    Media
  },
  data () {
    return {
      videoSource: '/vid/Hans-Lebrecht-Schule_Film-Tag-auf-Jugendstation.mp4',
      videoSourceAD: '/vid/Hans-Lebrecht-Schule_Film-Tag-auf-Jugendstation_audiodeskription.mp4',
      posterSource: '/img/projekte/tag_auf_jugendstation/thumbnail.jpg',
      videoType: 'video/mp4',
      videoIsPlaying: false,
      audioDescription: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      const video = this.$refs.videoEl
      if (video) {
        const track = document.createElement('track')
        track.kind = 'subtitles'
        track.src = '/vid/Hans-Lebrecht-Schule_Film-Tag-auf-Jugendstation.vtt'
        track.srclang = 'de'
        track.label = 'Deutsch'
        track.default = true
        video.appendChild(track)
        video.textTracks[0].mode = 'showing'
      }
    })
  },
  methods: {
    videoPlaying () {
      this.videoIsPlaying = true
    },
    videoStopped () {
      this.videoIsPlaying = false
    },
    toggleAudioDescription () {
      this.audioDescription = !this.audioDescription
      this.videoSource = this.audioDescription ? this.videoSourceAD : '/vid/Hans-Lebrecht-Schule_Film-Tag-auf-Jugendstation.mp4'
      const video = this.$refs.videoEl
      if (!video) return
      video.src = this.videoSource
      video.load()
      video.addEventListener('loadedmetadata', () => {
        if (video.textTracks && video.textTracks.length > 0) {
          video.textTracks[0].mode = this.audioDescription ? 'hidden' : 'showing'
        }
      }, { once: true })
    }
  },
  computed: {
    ...mapGetters([
      'menuData'
    ]),
    items () {
      return this.menuData.main.elements
        .map(id => this.menuData[id])
        .sort((a, b) => a.position - b.position)
    },
    computedAvatarSize () {
      if (this.$vuetify.breakpoint.name === 'lg') {
        return 100
      } else if (this.$vuetify.breakpoint.name === 'md') {
        return 80
      } else if (this.$vuetify.breakpoint.name === 'sm') {
        return 60
      } else {
        return 40
      }
    },
    computedVideoIsPlaying () {
      return this.videoIsPlaying
    }
  }
}
</script>

<style scoped>
.welcome-video-anchor {
  position: relative;
}
.welcome-video-title {
  overflow: hidden;
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  padding: 8px;
  color: white;
  background-color: #00000063;
  z-index: 10;
}
.welcome-video-title__show {
  opacity: 1;
}
.welcome-video-title__hide {
  opacity: 0;
  height: 0px;
}
</style>
